import React, { useContext, useEffect, useState } from "react";
import '../styles.css'
import Sidebar from "../../../layout/Sidebar/SideBar";
import Navbar from "../../../layout/Navbar/Navbar";
import blogFetch from "../../../axios/config";
import { ISAGA_Apontamento_SAP } from "../sapNotificationsInterfaces";
import Loading from "../../../components/Loading";

import { Table, TableContainer, TableHead, TableRow } from '@mui/material';
import { Select, MenuItem } from '@mui/material';
import { ListItemText, InputLabel, FormControl, Checkbox } from '@mui/material';

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'
import { Col, InputGroup, Form, Button } from "react-bootstrap";

export const ApontamentoPendente = () => {

    const [apontamentosHistorico, setApontamentosHistorico] = useState<ISAGA_Apontamento_SAP[]>([]);
    const [apontamentosPendentes, setApontamentosPendentes] = useState<ISAGA_Apontamento_SAP[]>([]);

    const tiposApontamentos: string[] = [
        "APROVADO",
        "REFUGO",
        "REPROCESSO"
    ];
    const [selectedApontamentos, setselectedApontamentos] = useState<string[]>(tiposApontamentos);

    const setores: string[] = [
        "01CORTE",
        "01HIDCOR",
        "03SERIG",
        "05EMPOLV",
        "06CURVAD",
        "09IOX_E",
        "09IOX_S",
        "12P_MONT",
        "13PRE_IB",
        "14MONTAG",
        "15EMBOL",
        "16ACV",
        "18INSFIN",
        "57LABORA"
    ];
    const [selectedSetor, setselectedSetor] = useState<string>("06CURVAD");
    const [dtInicio, setDtInicio] = useState<Date>(() => {
        const date = new Date();
        date.setDate(date.getDate() - 5);
        return date;
    });

    const [dtFim, setDtFim] = useState<Date>(new Date());


    const handleSelectSetor = (event: { target: { value: any; }; }) => {
        const {
            target: { value },
        } = event;
        setselectedSetor(value);
    };

    const handleSelectApontamentos = (event: { target: { value: any; }; }) => {
        const {
            target: { value },
        } = event;
        setselectedApontamentos(
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const getApontamentosPendentes = async (Setor: string) => {
        try {
            const { data } = await blogFetch.get(`/ISAGA_ApontamentoSAP/getApontamentoSAPPendentes?Setor=` + Setor);

            setApontamentosPendentes(data);
        } catch (error) {
            console.error(error);
        }
    };

    const getApontamentosHistorico = async () => {
        try {
            var str_dtInicio = dtInicio.toISOString().split('T')[0];
            var str_dtFim = dtFim.toISOString().split('T')[0];

            const { data } = await blogFetch.get(`/ISAGA_ApontamentoSAP/getApontamentoSAPHistorico?DtInicio=` + str_dtInicio + `&DtFim=` + str_dtFim + `&ApontStatus=` + selectedApontamentos.join(',') + `&Setor=` + selectedSetor);

            setApontamentosHistorico(data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getApontamentosPendentes(selectedSetor);
        getApontamentosHistorico();
    }, [dtInicio, dtFim, selectedApontamentos, selectedSetor]);

    const [searchApontamentosPendentes, setSearcApontamentosPendentes] = useState("");

    const filteredApontamentosHistorico = apontamentosPendentes.filter(
        ({ ordem_Fabricacao }) =>
            ordem_Fabricacao.toString().toLowerCase().includes(searchApontamentosPendentes.toLowerCase())
    );

    return (
        <>
            <Col>
                <h1 className="title_tables my-4">Apontamentos Pendentes</h1>
                <InputGroup className="mt-2 mb-3 w-25">
                    <Form.Control
                        placeholder="Buscar Peça - Ordem Serial"
                        value={searchApontamentosPendentes}
                        onChange={({ target }) => setSearcApontamentosPendentes(target.value)}
                    />
                </InputGroup>
                <div className="tableFixHeadApontSap tableFixHeadOverflowApontSap filawrap">
                    <table className="table tableFixBodyOverflowX">
                        <thead>
                            <tr>
                                {/* <th>KEY</th> */}
                                <th>CENTRO</th>
                                <th>MATRICULA</th>
                                <th>ORDEM</th>
                                <th>CHAVE</th>
                                <th>OPERACAO</th>
                                <th>TIPO APONT</th>
                                <th>DEF. GRUPO</th>
                                <th>DEF. CODIGO</th>
                                <th>ORIG. GRUPO</th>
                                <th>ORIG. CODIGO</th>
                                <th>CAUSA GRUPO</th>
                                <th>CAUSA CODIGO</th>
                                <th>DESTINO</th>
                                {/* <th>CSA DESV</th> */}
                                <th>ANULAR C/ REFUGO</th>
                                <th>OBS</th>
                                {/* <th>LOT COR</th>
                                <th>LOT CURV</th>
                                <th>CICLO IOX</th>
                                <th>CICLO AUTO</th>
                                <th>MAT</th>
                                <th>DESC</th>
                                <th>LOT</th> */}
                                <th>EQUIPAMENTO</th>
                                {/* <th>SEQ</th>
                                <th>LOT CARG</th>
                                <th>CAM</th>
                                <th>NRO RACK</th>
                                <th>NRO CX</th>
                                <th>NRO MOLDE</th>
                                <th>DESC MAT EMB</th> */}
                                <th>DATA CRIACAO</th>
                                <th>STATUS</th>
                                <th>TENTATIVAS</th>
                                {/* <th>INT LAST EXEC CRE DATE</th>
                                <th>INT LAST EXEC START DATE</th> */}
                                <th>DATA FIM</th>
                                {/* <th>INT REQ HDR</th>
                                <th>INT REQ BODY</th>
                                <th>INT RES STATUS CODE</th> */}
                                <th>RESULTADO</th>
                                <th>IGNORAR?</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredApontamentosHistorico.map((apontamento) => (
                                <tr key={apontamento.apont_Key}>
                                    <td>{apontamento.centro_Trabalho}</td>
                                    <td>{apontamento.nro_Matricula}</td>
                                    <td>{apontamento.ordem_Fabricacao}</td>
                                    <td>{apontamento.chave_Modelo}</td>
                                    <td>{apontamento.operacao}</td>
                                    <td>{apontamento.tipo_Apontamento}</td>
                                    <td>{apontamento.defeito_Grupo}</td>
                                    <td>{apontamento.defeito_Cod}</td>
                                    <td>{apontamento.origem_Grupo}</td>
                                    <td>{apontamento.origem_Cod}</td>
                                    <td>{apontamento.causa_Grupo}</td>
                                    <td>{apontamento.causa_Cod}</td>
                                    <td>{apontamento.destino}</td>
                                    {/* <td>{apontamento.causa_Desvio}</td> */}
                                    <td>{apontamento.anular_Com_Refugo ? 'Sim' : 'Não'}</td>
                                    <td>{apontamento.observacao}</td>

                                    {/* <td>{apontamento.lote_Corte}</td>
                                <td>{apontamento.lote_Curvado}</td>
                                <td>{apontamento.ciclo_IOX}</td>
                                <td>{apontamento.ciclo_Autoclave}</td>
                                <td>{apontamento.material}</td>
                                <td>{apontamento.descricao}</td>
                                <td>{apontamento.lote}</td> */}
                                    <td>{apontamento.equipamento}</td>
                                    {/* <td>{apontamento.sequencia}</td>
                                <td>{apontamento.lote_Carga}</td>
                                <td>{apontamento.camara}</td>
                                <td>{apontamento.numero_Rack}</td>
                                <td>{apontamento.numero_Caixa}</td>
                                <td>{apontamento.numero_Molde}</td>
                                <td>{apontamento.desc_Mat_Emb}</td> */}
                                    <td>{new Date(apontamento._ts_Creat).toLocaleString()}</td>
                                    <td>{apontamento.integration_Status}</td>
                                    <td>{apontamento.integration_LastExecutionID}</td>
                                    {/* <td>{apontamento.integration_LastExecutionCreateDate && new Date(apontamento.integration_LastExecutionCreateDate).toLocaleString()}</td> */}
                                    {/* <td>{apontamento.integration_LastExecutionStartedDate && new Date(apontamento.integration_LastExecutionStartedDate).toLocaleString()}</td> */}
                                    <td>{apontamento.integration_LastExecutionFinishedDate && new Date(apontamento.integration_LastExecutionFinishedDate).toLocaleString()}</td>
                                    {/* <td>{apontamento.integration_RequestHeader}</td> */}
                                    {/* <td>{apontamento.integration_RequestBody}</td> */}
                                    {/* <td>{apontamento.integration_ResultStatusCode}</td> */}
                                    <td>{apontamento.integration_Result}</td>
                                    <td>{apontamento.integration_Ignore ? 'Sim' : 'Não'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </Col>
        </>
    )
}

